import {NgModule} from '@angular/core';
import {
    AbstractSecurityStorage,
    AuthModule, StsConfigLoader
} from 'angular-auth-oidc-client';
import {AuthSessionStorageService} from './services/auth-session-storage-service';
import {configLoaderFactory} from './services/config-loader-factory';
import {HttpClient} from '@angular/common/http';

@NgModule({
    declarations: [],
    imports: [
        AuthModule.forRoot({
            loader: {
                provide: StsConfigLoader,
                useFactory: configLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        {
            provide: AbstractSecurityStorage,
            useClass: AuthSessionStorageService,
        }
    ],
    exports: [AuthModule]

})
export class AuthAppModule {}

